<script>
import CompanyTabLayout from '@/components/company/CompanyTabLayout.vue';
import OrdersList from '@/pages/orders/OrdersList.vue';

export default {
  components: {
    CompanyTabLayout,
    OrdersList,
  },
};
</script>

<template>
  <CompanyTabLayout active-tab="orders" v-slot="{ companyId }">
    <OrdersList :company-id="companyId" />
  </CompanyTabLayout>
</template>
